import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b31d1a0e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "talk" }
const _hoisted_2 = { class: "content" }
const _hoisted_3 = { class: "chat-frame" }
const _hoisted_4 = { class: "chat-frame-top" }

import { ArrowRight } from "@element-plus/icons-vue";
import { useStore } from "vuex";
import { ref, onMounted, watch, reactive, onUnmounted } from "vue";
import order from "@/api/order";
import router from "@/router";
import FileUpload from "@/components/talkMessage/FileUpload.vue";
import Send from "@/components/talkMessage/Send.vue";
import Card from "@/components/talkMessage/Card.vue";
import OrderOne from "@/components/talkMessage/Order.vue";
import Countdown from "@/components/talkMessage/Countdown.vue";
import { useRoute } from "vue-router";
import { DefaultWebServiceFactory } from "@/services/webapi/DefaultWebServiceFactory";

interface _breadData {
  //订单状态
  orderType: string;
  //属于那个类目
  orderState: string;
  //房间号
  orderId: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'Talk',
  setup(__props) {

const backRote = ref<string>();
const attorneyState = ref<boolean>(true);
const rid = ref<string>("");
const $store = useStore();
let breadData = reactive<_breadData>({
  orderType: "",
  //属于那个类目
  orderState: "",
  //房间号
  orderId: "",
});
const confirm = () => order.endOrder(Number(rid.value));
// 发送信息

const route = useRoute();
watch(route, () => {
  window.location.reload();
  loadTalk();
});
watch($store.state.talk.serviceExpireTime, () => {
  loadTalk();
});
const routeHistory = ref<string>();
const goBack = () => {
  routeHistory.value
    ? router.replace(routeHistory.value)
    : router.replace("/layout/home");
};
const loadTalk = async () => {
  rid.value = router.currentRoute.value.query.rid as string;
  const { code, breadType } = router.currentRoute.value.query;
  attorneyState.value = code == "true" ? true : false;
  const getOrder = await order.getOrder(Number(rid.value));
  $store.commit(
    "talk/updateTargetId",
    attorneyState.value
      ? getOrder.initiatorInfo.entityId
      : getOrder.servingProfessionalInfo.entityId
  );
  $store.commit(
    "talk/updateCorrelationId",
    attorneyState.value
      ? getOrder.servingProfessionalInfo.entityId
      : getOrder.initiatorInfo.entityId
  );
  const list = [
    [
      getOrder.status === 13 ||
      Number($store.state.talk.serviceExpireTime[rid.value]) == 11
        ? "已完成需求"
        : "处理中需求",
      getOrder.trade
        ? getOrder.trade.title
        : router.currentRoute.value.query.title,
    ],
    ["通知", getOrder.trade ? getOrder.trade.title : "44444"],
    ["购买的服务", "使用过的服务"],
    ["购买的服务", "全部订单"],
  ];
  const routeMenu = [
    "/layout/home",
    "/layout/message",
    "/layout/order",
    "/layout/order",
  ];
  routeHistory.value = routeMenu[Number(breadType)];
  backRote.value = routeMenu[Number(breadType)];
  breadData.orderType = list[breadType as string][0];
  breadData.orderState = router.currentRoute.value.query.title;
  breadData.orderId = rid.value;
};
const go = () => {
  if (breadData.orderType === "购买的服务") {
    router.push({
      path: "/layout/order",
    });
    return;
  }
  const list: string[] = ["待处理需求", "处理中需求", "已完成需求"];
  router.push({
    path: "/layout/home",
    query: {
      index: list.findIndex((value) => value === breadData.orderType),
    },
  });
};
const goo = async () => {
  const getOrder = await order.getOrder(Number(rid.value));
  if (breadData.orderType === "购买的服务") {
    router.push({
      path: "/layout/order",
    });
    return;
  }
  const list: string[] = ["待处理需求", "处理中需求", "已完成需求"];
  router.push({
    path: "/layout/home",
    query: {
      index: list.findIndex((value) => value === breadData.orderType),
      _index: router.currentRoute.value.query.index,
      num: router.currentRoute.value.query.num,
      title: router.currentRoute.value.query.title,
    },
  });
};
onMounted(() => {
  if (window.history && window.history.pushState) {
    history.pushState(null, null, document.URL);
    window.addEventListener("popstate", goBack, false);
  }
  loadTalk();
});
onUnmounted(() => {
  window.removeEventListener("popstate", goBack, false);
});

return (_ctx: any,_cache: any) => {
  const _component_el_breadcrumb_item = _resolveComponent("el-breadcrumb-item")!
  const _component_el_breadcrumb = _resolveComponent("el-breadcrumb")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_el_breadcrumb, { "separator-icon": _unref(ArrowRight) }, {
      default: _withCtx(() => [
        _createVNode(_component_el_breadcrumb_item, { onClick: go }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(breadData).orderType), 1)
          ]),
          _: 1
        }),
        _createVNode(_component_el_breadcrumb_item, { onClick: goo }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(breadData).orderState), 1)
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["separator-icon"]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(Countdown, { rid: rid.value }, null, 8, ["rid"]),
          (attorneyState.value)
            ? _withDirectives((_openBlock(), _createElementBlock("button", {
                key: 0,
                onClick: confirm
              }, " 结束服务 ", 512)), [
                [_vShow, _unref($store).state.talk.serviceExpireTime[rid.value] != 11]
              ])
            : _withDirectives((_openBlock(), _createElementBlock("button", {
                key: 1,
                onClick: confirm
              }, " 完成服务 ", 512)), [
                [_vShow, _unref($store).state.talk.serviceExpireTime[rid.value] != 11]
              ])
        ]),
        _createVNode(Card, {
          attorneyState: attorneyState.value,
          rid: rid.value,
          "order-state": ""
        }, null, 8, ["attorneyState", "rid"]),
        _createVNode(FileUpload, { rid: rid.value }, null, 8, ["rid"]),
        _createVNode(Send, { rid: rid.value }, null, 8, ["rid"])
      ]),
      _createVNode(OrderOne, {
        attorneyState: attorneyState.value,
        rid: rid.value,
        title: _unref(router).currentRoute.value.query.title,
        type: _unref(router).currentRoute.value.query.type
      }, null, 8, ["attorneyState", "rid", "title", "type"])
    ])
  ]))
}
}

})